import Paper from '@mui/material/Paper';
import { ELEVATION } from '@openx/components-core/lib/theme/elevation.ts';

import type { ReactNode } from 'react';

type ItemContainerProps = {
  children: ReactNode;
  isExclude?: boolean;
  dataTestId?: string;
};

export const ItemContainer = ({ children, isExclude, dataTestId }: ItemContainerProps) => {
  return (
    <Paper
      data-test={dataTestId}
      sx={{
        boxShadow: ELEVATION.elevation0,
        mb: 2,
        mt: 2,
        borderColor: 'divider',
        backgroundColor: isExclude ? 'error.light' : 'background.boxLight',
      }}
    >
      {children}
    </Paper>
  );
};
